import { getDataFromElement } from './utils/index.js';

/*
  Keeps site configuration from SiteRepository.
  Prefer this over passing setting to a component.
*/

/**
 * @typedef {object} SiteConfiguration
 * @property {boolean} enableRightToLeftLayout Displaying site in Right To Left layout.
 * @property {boolean} enableAssetBarOnRange Enable showing of the highlighted documents on the range pages.
 * @property {boolean} enableAnalytics The flag determines enable/disable Google Analytics.
 */

/** @type {SiteConfiguration} */
let siteConfiguration;

/** @returns {SiteConfiguration} */
export function getSiteConfiguration() {
  if (!siteConfiguration) {
    siteConfiguration = getDataFromElement(document.getElementById('site-configuration'));
  }

  return siteConfiguration;
}
